export const lessonsWord = (count) => {
  const n = Math.abs(Number(count) || 0);
  const mod100 = n % 100;
  const mod10 = n % 10;

  if (mod100 >= 11 && mod100 <= 14) {
    return 'уроків';
  }
  if (mod10 === 1) {
    return 'урок';
  }
  if (mod10 >= 2 && mod10 <= 4) {
    return 'уроки';
  }

  return 'уроків';
};

export const formatMoney = (value) => {
  const num = Number(value) || 0;

  return num.toLocaleString('uk-UA', { minimumFractionDigits: 0, maximumFractionDigits: 2 }).split(String.fromCharCode(160)).join(' ').split(String.fromCharCode(8239)).join(' ');
};
